module.exports = __webpack_public_path__ + "img/dhaly 1.a6ec2ffc.png";